import React from "react";
import { Slide } from "react-reveal";
import Strengthcard from "../reusables/StrengthCard";

const WhyJM = () => {
  return (
    <section className="section section-spacing-100 strength-pull">
      <div className="container">
        <div className="large">
          <div className="section-content">
            <div className="width-600">
              <p className="section-name boldTitle dark">
                VALUES &amp; STRENGTHS
              </p>
              <Slide top>
                <div className="section-head">
                  <h2 className="section-title green">WHY NEGASH CONSTRUCTION COMPANY?</h2>
                </div>
              </Slide>
            </div>
            <div className="section-body section-spacing-20">
              <ul className="strengths-cards-container">
                <Slide top>
                  <Strengthcard
                    caption="We believe in"
                    strength="creating lasting value for our clients and communities"
                  />
                </Slide>
                <Slide bottom>
                  <Strengthcard
                    caption="our ethics"
                    strength="Welfare, Honesty, professionalism &amp; accountability"
                  />
                </Slide>
                <Slide top>
                  <Strengthcard
                    caption="our workforce"
                    strength="Experienced, Well trained and in enough numbers"
                  />
                </Slide>
                <Slide bottom>
                  <Strengthcard
                    caption="experience &amp; success"
                    strength="Over 120 years of combined individual experience"
                  />
                </Slide>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyJM;
